import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';
import moment from 'moment';

const options = {
  name: 'personnelTransfers',
  baseType: 'PERSONNEL_TRANSFERS',
  apiEndpoint: 'personnel_transfers',
  createNew: () => ({
    origin_group_id: null,
    destination_group_id: null,
    start_time: moment().startOf('hour'),
    end_time: moment().add(2, 'hour')
  })
};

const operations = createMetadataAPIOperations(options);
const selectors = createMetadataAPISelectors(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
